import * as React from "react";

const IconHolderInfo = (props) => (
  <svg
    width={64}
    height={64}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M54.092 51.247 22.514 59.7c-4.237 1.138-8.601-1.392-9.74-5.629L4.3 22.493c-1.138-4.237 1.37-8.6 5.608-9.74l31.578-8.452c4.258-1.139 8.622 1.37 9.76 5.607L59.7 41.486c1.138 4.259-1.37 8.622-5.608 9.76Z"
      fill="#D7DBF5"
    />
    <path
      d="m51.267 23.715-26.814 12.69a56.184 56.184 0 0 0 8.496 14.82c2.192 0 4.3-.358 6.303-.99l-.127.569 4.174-2.34a20.647 20.647 0 0 0 10.16-15.03l1.687-11.89-3.879 2.171Z"
      fill="#141938"
    />
    <path
      d="M40.095 1.16 22.092 2.465l-3.879 2.171 33.054 19.078 3.88-2.171L40.094 1.159Z"
      fill="#FF858D"
    />
    <path
      d="M25.591 46.756c-6.45-8.074-9.296-18.572-7.841-28.817l1.707-11.973 16.063-1.18 14.25 19.288-1.601 11.299c-1.307 9.233-9.17 16.232-18.425 16.569l-4.152-5.186Z"
      fill="#FAFBFF"
    />
    <path
      d="M32.316 27.51c-3.415-1.96-5.27-5.818-4.7-9.718.484-3.33 4.194-5.123 7.103-3.457a9.22 9.22 0 0 1 4.553 9.38l-.063.422c-.464 3.267-4.068 5.017-6.893 3.373ZM28.079 26.603l-.169-.105c-2.909-1.623-6.556.168-7.04 3.478l-1.265 8.559 10.118 13.512 10.877-3.33 1.139-7.02a9.885 9.885 0 0 0-4.828-9.993l-.105-.063-8.727-5.038Z"
      fill="#FF1C44"
    />
    <path
      d="m34.825 6.282 13.428 18.193-1.518 10.73c-1.18 8.305-8.095 14.672-16.337 15.304l-3.69-4.617c-6.197-7.778-8.937-17.876-7.546-27.72l1.539-10.836 14.124-1.054Zm1.37-2.951L18.213 4.638 16.337 17.75a39.197 39.197 0 0 0 8.137 29.913l4.575 5.755c10.308 0 19.056-7.589 20.51-17.813l1.687-11.89L36.195 3.332Z"
      fill="#FFCA61"
    />
  </svg>
);

export default IconHolderInfo;
